// NapflixOS Overlay Manager v6
// Runtime stack foundation only. This module does not render UI.
let overlayState = {
  stack: [],
  topOverlay: null,
  hasModalOverlay: false,
};

const listeners = new Set();

const normalizeOverlay = (overlay) => ({
  id: overlay.id,
  type: overlay.type,
  priority: overlay.priority ?? 0,
  modal: !!overlay.modal,
  focusTrap: !!overlay.focusTrap,
  openedAt: overlay.openedAt || Date.now(),
  payload: overlay.payload ?? null,
});

const deriveOverlayState = (stack) => {
  const sortedStack = [...stack].sort((a, b) => {
    if (a.priority !== b.priority) return a.priority - b.priority;
    return a.openedAt - b.openedAt;
  });
  const topOverlay = sortedStack[sortedStack.length - 1] || null;

  return {
    stack: sortedStack,
    topOverlay,
    hasModalOverlay: sortedStack.some((overlay) => overlay.modal),
  };
};

export function getOverlayState() {
  return overlayState;
}

export function setOverlayState(partial) {
  const nextStack = partial.stack
    ? partial.stack.map(normalizeOverlay)
    : overlayState.stack;

  overlayState = {
    ...overlayState,
    ...partial,
    ...deriveOverlayState(nextStack),
  };

  listeners.forEach((listener) => listener(overlayState));
}

export function subscribeOverlayState(listener) {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function openOverlay(overlay) {
  if (!overlay?.id || !overlay?.type) {
    return getOverlayState();
  }

  const nextOverlay = normalizeOverlay(overlay);
  const nextStack = [
    ...overlayState.stack.filter((item) => item.id !== nextOverlay.id),
    nextOverlay,
  ];

  setOverlayState({ stack: nextStack });
  return getOverlayState();
}

export function closeOverlay(id) {
  if (!id) return getOverlayState();

  setOverlayState({
    stack: overlayState.stack.filter((overlay) => overlay.id !== id),
  });

  return getOverlayState();
}

export function closeTopOverlay() {
  if (!overlayState.topOverlay) return getOverlayState();

  return closeOverlay(overlayState.topOverlay.id);
}

export function clearOverlays() {
  setOverlayState({ stack: [] });
  return getOverlayState();
}
